var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyldBrandPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 712 298",
    style: {
      enableBackground: "new 0 0 712 298"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF308;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "brand/full logo/black background copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1.1-UI"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L-1-00_Dashboard_log_in",
    transform: "translate(-728.000000, -602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand_x2F_full-logo_x2F_black-background-copy",
    transform: "translate(728.000000, 602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FYLD_RGB_BBG_FULL-LOGO_COLOUR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(0.092683, 0.075741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st0",
    points: "55.5,296.9 69.1,296.9 69.1,67.8 712.4,67.8 712.4,54.3 69.1,54.3 69.1,40.7  712.4,40.7 712.4,27.2 55.5,27.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_1_",
    className: "st0",
    points: "0.7,296.9 14.2,296.9 14.2,14.2 27.7,14.2 27.7,296.9 41.3,296.9 41.3,14.2  712.4,14.2 712.4,0.7 0.7,0.7  "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyldBrandPattern);
export default __webpack_public_path__ + "static/media/fyld_brand_pattern.10bdb6c53786599f3d1ded069cf1abf9.svg";
export { ForwardRef as ReactComponent };